<template lang="pug">
  .view-control-settings-categories

    b-table(:data="tabCategories" :loading="categories.$state.loading")
      b-table-column(field="id" label="ID" width="30" numeric sortable v-slot="{row}") {{ row.id }}
      b-table-column(field="name" label="Название" sortable v-slot="{row}") {{row.name}}
      b-table-column(field="actions" label="Действия" width="30" v-slot="{row}")
        router-link(:to="{name: 'control.category.edit', params: {id: row.id}}")
          ui-button.is-small.is-rounded(icon="pencil-circle" icon-type="is-info") Редактировать

      //- Добавление новой категории
      template(v-slot:footer)
        th(colspan="3")
          form(@submit.prevent)
            .field.has-addons
              .control.is-expanded
                b-input(type="text" v-model="newCategory.name" placeholder="Добавить элемент" :loading="newCategory.$state.saving")
              .control
                ui-button.is-primary(icon="plus" :disabled="!newCategory.$isChanged" @click="saveNewCategory") Добавить

      //- Пусто
      template(v-slot:empty)
        section.section(v-if="categories.$state.loaded")
          .content.has-text-grey.has-text-centered
            p: b-icon(icon="emoticon-sad" size="is-large")
            p Нет записей
</template>

<script>
import Category from '@/models/Category';

export default {
  name: 'view-control-settings-categories',

  data: () => ({
    categories: Category.collection(),
    newCategory: new Category(),
    activeTab: 0,
    tabs: [{ name: 'Активные категории материалов', filter: {} }],
  }),

  methods: {
    saveNewCategory() {
      this.newCategory.$save().then(() => {
        this.categories.add(this.newCategory);
        this.newCategory = new Category();
      });
    },
  },

  computed: {
    currentTabFilter() {
      return this.tabs[this.activeTab].filter;
    },

    tabCategories() {
      return this.categories.filter(this.currentTabFilter);
    },
  },

  created() {
    this.categories.$fetch();
  },
};
</script>
